import React from "react";
import { useField } from "formik";
import { Select as AntdSelect } from "antd";

interface SelectProps {
  name: string;
  label?: string;
  options: Array<{
    label: string;
    value: string | number;
  }>;
  placeholder?: string;
  wrapperClassName?: string;
  className?: string;
  onChange?: (value: string | number) => void;
  onClear?: () => void;
  allowClear?: boolean;
}

const Select: React.FC<SelectProps> = ({
  name,
  label,
  options,
  placeholder,
  className,
  onChange,
  wrapperClassName,
  onClear,
  allowClear,
  ...props
}) => {
  const [field, meta] = useField(name);
  return (
    <div className={`flex flex-col gap-2 w-full ${wrapperClassName}`}>
      {label && (
        <label htmlFor={name} className="text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <AntdSelect
        id={name}
        {...field}
        {...props}
        value={field.value}
        onChange={(value) => {
          if (!!onChange) onChange(value);
          field.onChange({ target: { name, value } });
        }}
        options={options}
        placeholder={placeholder}
        className={className}
        onClear={onClear}
        allowClear={allowClear}
        style={{ width: "100%" }}
      />
      {meta.touched && meta.error && (
        <div className="text-error text-sm mt-1">{meta.error}</div>
      )}
    </div>
  );
};

export default Select;
